"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHILD_ADULT_INSIDE_CANADA_STUDY_INTAKE = exports.CHILD_TEEN_INSIDE_CANADA_STUDY_INTAKE = exports.CHILD_INSIDE_CANADA_STUDY_INTAKE = exports.PARTNER_INSIDE_CANADA_STUDY_INTAKE = exports.APPLICANT_INSIDE_CANADA_STUDY_INTAKE = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
const question_groups_1 = require("../../groups/question-groups");
const form_1 = require("../../utils/form");
const defaults_1 = require("../defaults");
exports.APPLICANT_INSIDE_CANADA_STUDY_INTAKE = (0, form_1.form)({
    name: "APPLICANT_INSIDE_CANADA_STUDY_INTAKE",
    title: "Intake form for inside Canada Study Permit",
    content: [
        question_groups_1.QuestionGroup["COMING_INTO_CANADA"],
        question_groups_1.QuestionGroup["APPLICANT_INTENDED_STUDY_DETAILS"],
        ...defaults_1.APPLICANT_DEFAULT_QUESTION_GROUPS.filter((questionGroup) => !defaults_1.ALL_FAMILY_INFO_GROUPS.includes(questionGroup.uniqueKey)),
    ],
    id: 56,
});
exports.PARTNER_INSIDE_CANADA_STUDY_INTAKE = (0, form_1.form)({
    name: "PARTNER_INSIDE_CANADA_STUDY_INTAKE",
    title: "Intake form for inside Canada Work Permit",
    content: [
        question_groups_1.QuestionGroup["COMING_INTO_CANADA"],
        ...defaults_1.PARTNER_DEFAULT_QUESTION_GROUPS.filter((questionGroup) => !defaults_1.ALL_FAMILY_INFO_GROUPS.includes(questionGroup.uniqueKey)),
    ],
    id: 57,
});
exports.CHILD_INSIDE_CANADA_STUDY_INTAKE = (0, form_1.form)({
    name: "CHILD_INSIDE_CANADA_STUDY_INTAKE",
    title: "Intake form for inside Canada Visitor Visa",
    content: [
        question_groups_1.QuestionGroup["COMING_INTO_CANADA"],
        question_groups_1.QuestionGroup["DETAILS_VISIT_INSIDE_CANADA_ALL_QUESTIONS"],
        ...defaults_1.CHILD_AND_CHILD_TEEN_DEFAULT_QUESTION_GROUPS.filter((questionGroup) => !defaults_1.ALL_FAMILY_INFO_GROUPS.includes(questionGroup.uniqueKey)),
    ],
    id: 58,
});
exports.CHILD_TEEN_INSIDE_CANADA_STUDY_INTAKE = (0, form_1.form)({
    name: "CHILD_TEEN_INSIDE_CANADA_STUDY_INTAKE",
    title: "Intake form for inside Canada Study Permit",
    content: [
        question_groups_1.QuestionGroup["COMING_INTO_CANADA"],
        ...defaults_1.CHILD_AND_CHILD_TEEN_DEFAULT_QUESTION_GROUPS.filter((questionGroup) => !defaults_1.ALL_FAMILY_INFO_GROUPS.includes(questionGroup.uniqueKey)),
    ],
    id: 59,
});
exports.CHILD_ADULT_INSIDE_CANADA_STUDY_INTAKE = (0, form_1.form)({
    name: "CHILD_ADULT_INSIDE_CANADA_STUDY_INTAKE",
    title: "Intake form for inside Canada Study Permit",
    content: [
        question_groups_1.QuestionGroup["COMING_INTO_CANADA"],
        ...defaults_1.CHILD_ADULT_DEFAULT_QUESTION_GROUPS.filter((questionGroup) => !defaults_1.ALL_FAMILY_INFO_GROUPS.includes(questionGroup.uniqueKey)),
    ],
    id: 60,
});
